import React from 'react';
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import "./index.scss";

import { assetImg } from "@/modules/moduleImporter";
import { IGameTableType } from "@/types/GlobalTypes";
import { IPokerDiceHistoryType } from "@/types/GameHistoryTypes";
import { betGroupProp } from "@/modules/commonMobile";
import nary from "@/modules/nary";

interface IProps extends Omit<IGameTableType, "win"> {
	win: IPokerDiceHistoryType;
}

export default class M14 extends React.PureComponent<IProps> {
	render() {
		const { langdata } = this.props;
		
		const win = this.props.win || { angka2: "", angka3: "" };

		const winsplit = (win.angka2 || "").split(",");

		let reds = 0;
		let smalls = 0;
		let odds = 0;
		const winC = {};

		winsplit.forEach(dice => {
			if (dice[1] === "r") reds++;
			if (+dice[0] < 4) smalls++;
			if (+dice[0] % 2) odds++;

			winC[dice[0]] = (winC[dice[0]] || 0) + 1;
		});


		//Desktop
		//INC=Incomplete
		const betKeyAry = ["2 Pairs", "3 of a Kind", "INC Straight", "FLUSH", "Full House", "Straight", "4 of a Kind", "INC Straight Flush", "Straight Flush", "Red", "5 of a Kind", "Black"];
		const betKeyNames = [
			this.props.langdata["txt_2_pairs"], this.props.langdata["txt_3_of_a_kind"], this.props.langdata["txt_inc_straight"],
			this.props.langdata["txt_flush"], this.props.langdata["txt_full_house"], this.props.langdata["txt_straight"],
			this.props.langdata["txt_4_of_a_kind"], this.props.langdata["txt_inc_straight_flush"], this.props.langdata["txt_straight_flush"],
			"", this.props.langdata["txt_5_of_a_kind"], ""
		];

		//Mobile
		const mobileBetKeyAry = ["2 Pairs", "3 of a Kind", "INC Straight", "FLUSH", "Full House", "Straight", "4 of a Kind", "INC Straight Flush", "Straight Flush"];
		const mobilePortraitLangDataAry = [
			this.props.langdata["txt_2_pairs"], this.props.langdata["txt_3_of_a_kind"], this.props.langdata["txt_inc_straight"],
			this.props.langdata["txt_flush"], this.props.langdata["txt_full_house"], this.props.langdata["txt_straight"],
			this.props.langdata["txt_4_of_a_kind"], this.props.langdata["txt_inc_straight_flush"], this.props.langdata["txt_straight_flush"],
			this.props.langdata["txt_5_of_a_kind"]
		];

		const betTypes = ["1:3", "1:5", "1:16", "1:18", "1:23", "1:33", "1:47", "1:140", "1:285", "1:0.95", "1:1100", "1:0.95"];

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		return (
			this.props.portrait ?
				<div className="sl-table m14-portrait">
					<div className="row">
						<div className={"sl-bet col-xs-6 sl-green-new" + (smalls > 2 ? " sl-yellow-alternating" : "")}
							{...betGroupProp(this, "Small", "n50")}
							// bet="Small" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet}>
							{this.props.langdata["txt_small"]}
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Small+n50" />
						</div>
						<div className={"sl-bet col-xs-6 sl-green-new" + (smalls < 3 && win.angka2 !== "" ? " sl-yellow-alternating" : "")}
							{...betGroupProp(this, "Big", "n50")}
							// bet="Big" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet}>
							{this.props.langdata["txt_big"]}
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Big+n50" />
						</div>
					</div>

					<div className="row">
						{/* odds > 2 */}
						<div className={"sl-bet col-xs-6 sl-cyan-new" + (odds < 3 && win.angka2 !== "" ? " sl-yellow-alternating" : "")}
							{...betGroupProp(this, "Odd", "n50")}
							// bet="Odd" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet}>
							{this.props.langdata["txt_odd"]}
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Odd+n50" />
						</div>
						{/* odds < 3 */}
						<div className={"sl-bet col-xs-6 sl-cyan-new" + (odds >= 3 && win.angka2 !== "" ? " sl-yellow-alternating" : "")}
							{...betGroupProp(this, "Even", "n50")}
							// bet="Even" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet}>
							{this.props.langdata["txt_even"]}
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Even+n50" />
						</div>
					</div>

					<div className="row">
						<div className={"sl-bet col-xs-6 sl-red-lighten" + ((reds > 2) ? " sl-yellow-alternating" : "")}
							{...betGroupProp(this, "Red", "n50")}
							// bet="Red" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet}>
							{this.props.langdata["txt_red"]}
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Red+n50" />
						</div>
						<div className={"sl-bet col-xs-6 sl-black-lighten" + (reds < 3 && win.angka2 !== "" ? " sl-yellow-alternating" : "")}
							{...betGroupProp(this, "Black", "n50")}
							// bet="Black" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet}>
							{this.props.langdata["txt_black"]}
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Black+n50" />
						</div>
					</div>

					<div className="row">
						{
							nary(6).map((item, idx) => {
								const betKey = item + "-" + item;
								return <div key={"m14_" + idx}
									className={"sl-bet col-xs-2 m14-tall sl-green-old" + (win.angka3 === betKey ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, betKey, "1pair")}
									// bet={betKey} pcode={this.props.pcode} group="1pair"
									onClick={this.props.insertBet}>
									{assetImg("m14", item + "", "p_m14_" + idx, "dice")}
									{assetImg("m14", item + "", "p_m14_" + idx, "dice")}

									{
										// <img className="dice" src={dices[item]} alt={"Dice " + item}/>
										// <img className="dice" src={dices[item]} alt={"Dice " + item}/>
									}
									<div className="bet-type">1:12</div>
									<Chips {...commonChipProps} betKey={betKey + "+1pair"} />
								</div>;
							})
						}
					</div>

					<div className="row">
						{
							mobileBetKeyAry.map((betKey, betKeyIdx) => {
								const betgroup = betKey.toLowerCase().replace(/\.| /g, "");
								return <div key={"m14_" + betKeyIdx}
									className={"sl-bet m14 col-xs-4 sl-green-old" + (win.angka3 === betKey ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, betKey, betgroup)}
									// bet={betKey} pcode={this.props.pcode} group={betgroup}
									onClick={this.props.insertBet}>
									{mobilePortraitLangDataAry[betKeyIdx]}
									<div className="bet-type">{betTypes[betKeyIdx]}</div>
									<Chips {...commonChipProps} betKey={betKey + "+" + betgroup} />
								</div>;
							})
						}
					</div>

					<div className="row">
						<div className="sl-bet col-xs-12 sl-green-old"
							{...betGroupProp(this, "5 of a Kind", "5ofakind")}
							// bet="5 of a Kind" pcode={this.props.pcode} group={"5ofakind"}
							onClick={this.props.insertBet}>
							{this.props.langdata["txt_5_of_a_kind"]}
							<div className="bet-type">1:1100</div>
							<Chips {...commonChipProps} betKey={"5 of a Kind+5ofakind"} />
						</div>
					</div>
				</div>


				: <div className="sl-table">
					<div className="m14-table">
						<div className="dice-box">
							{
								nary(6).map((item, idx) => {
									const betKey = item + "-" + item;
									return (
										<div key={"m14_" + idx} className={"sl-bet sl-green-old"
											/* sl-red" + (idx % 2 ? "" : "-darken") */
											+ (win.angka3 === betKey ? " sl-yellow-alternating" : "")}
											{...betGroupProp(this, betKey, "1pair")}
											// bet={betKey} pcode={this.props.pcode} group="1pair"
											onClick={this.props.insertBet}>

											{assetImg("m14", item + "", "m14_dice-box_1_" + idx, "dice")}
											{assetImg("m14", item + "", "m14_dice-box_2_" + idx, "dice")}

											{
												// <img className="dice" src={dices[item]} alt={"Dice " + item}/>
												// <img className="dice" src={dices[item]} alt={"Dice " + item}/>
											}
											<div className="bet-type">1:12</div>
											<Chips {...commonChipProps} betKey={betKey + "+1pair"} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+1pair"]} />
										</div>);
								})
							}
						</div>
						<div className="bet-box">
							<div className="sides">
								<div className={"sl-bet sl-green-new" + (smalls > 2 ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, "Small", "n50")}
									// bet="Small" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet}>
									<div>{this.props.langdata["txt_small"]}</div>
									<div className="bet-type">1:0.95</div>
									<Chips {...commonChipProps} betKey="Small+n50" />
									<Tooltip {...commonTooltipProps} bet={this.props.bets["Small+n50"]} />
								</div>
								{/*odds > 2*/}
								<div className={"sl-bet sl-cyan-new" + (odds >= 3 ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, "Odd", "n50")}
									// bet="Odd" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet}>
									<div>{this.props.langdata["txt_odd"]}</div>
									<div className="bet-type">1:0.95</div>
									<Chips {...commonChipProps} betKey="Odd+n50" />
									<Tooltip {...commonTooltipProps} bet={this.props.bets["Odd+n50"]} />
								</div>
							</div>
							<div className="main-bet-box">
								{
									betKeyAry.map((betKey, idx) => {
										const betgroup = (betKey === "Black" || betKey === "Red") ? "n50" : betKey.toLowerCase().replace(/\.| /g, "");
										const bg = " sl-green-old";
										return (
											<div key={"m14_" + betKey} className={"sl-bet" + bg
												+ (win.angka3 === betKey ? " sl-yellow-alternating"
													: ((reds > 2 && betKey === "Red") || (reds < 3 && betKey === "Black" && win.angka2 !== "") ? " sl-yellow-alternating" : ""))}

												{...betGroupProp(this, betKey, betgroup)}
												// bet={betKey} pcode={this.props.pcode} group={betgroup}
												onClick={this.props.insertBet}>
												{(betKey === "Black" || betKey === "Red")
													? <div className={"sl-" + (betKey === "Red" ? "red-darken" : "black") + " m14-diamond"}></div>
													: (<div className="m14-bet-text">
														<span>{betKeyNames[idx]}</span>
														{/*  this.props.maximised ? <span>{betKey.replace(".", ". ")}</span> : <span>{betKey.toUpperCase().replace(".", ". ")}</span>  */}
													</div>)}

												<div className="bet-type">{betTypes[idx]}</div>
												<Chips {...commonChipProps} betKey={betKey + "+" + betgroup} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+" + betgroup]} />
											</div>
										);
									})
								}
							</div>
							<div className="sides">
								<div className={"sl-bet sl-green-new" + (smalls < 3 && win.angka2 !== "" ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, "Big", "n50")}
									// bet="Big" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet}>
									<div>{this.props.langdata["txt_big"]}</div>
									<div className="bet-type">1:0.95</div>
									<Chips {...commonChipProps} betKey="Big+n50" />
									<Tooltip {...commonTooltipProps} bet={this.props.bets["Big+n50"]} />
								</div>
								{/*odds < 3*/}
								<div className={"sl-bet sl-cyan-new" + (odds < 3 && win.angka2 !== "" ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, "Even", "n50")}
									// bet="Even" pcode={this.props.pcode} group="n50"
									onClick={this.props.insertBet}>
									<div>{this.props.langdata["txt_even"]}</div>
									<div className="bet-type">1:0.95</div>
									<Chips {...commonChipProps} betKey="Even+n50" />
									<Tooltip {...commonTooltipProps} bet={this.props.bets["Even+n50"]} />
								</div>
							</div>
						</div>
					</div>
				</div>
		);
	}
}
